<template>
  <SelectProPlan
    class="pt-[26px] tablet-v:pt-[111px] px-[18px]"
    :type="SelectPlanType.Onboarding"
  />
</template>

<script setup lang="ts">
import SelectProPlan from '@/features/billing/components/SelectProPlan.vue'
import { SelectPlanType } from '@/shared/types/index'
</script>
